import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IEmployeeRole, IRole} from '../interfaces/roles.interace';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private urlRole = environment.API + 'api/v1/Role/';
  private urlReq = environment.API + 'api/v1/Request/';

  constructor(private http: HttpClient) {}

  getRolesDropdown(): Observable<IRole[]> {
    return this.http.get<IRole[]>(`${this.urlRole}RoleDropDown`);
  }

  getEmployeeRoles(): Observable<IEmployeeRole[]> {
    return this.http.get<IEmployeeRole[]>(`${this.urlRole}Users`);
  }

  updateRole(employeeId: number, role: IRole): Observable<IEmployeeRole[]> {
    return this.http.post<IEmployeeRole[]>(`${this.urlReq}RoleRequest`, {
      employeeId,
      role,
    });
  }

  deleteRole(id: number): Observable<IEmployeeRole[]> {
    return this.http.delete<IEmployeeRole[]>(
      `${this.urlRole}DeleteUserRole/${id}`
    );
  }

  getDeletedEmployees(): Observable<IEmployeeRole[]> {
    return this.http.get<IEmployeeRole[]>(`${this.urlRole}Users/DeletedRoles`);
  }

  searchActiveRole(searchWord: string): Observable<IEmployeeRole[]> {
    return this.http.get<IEmployeeRole[]>(
      `${this.urlRole}Users/DeletedRoles/${searchWord}`
    );
  }

  searchDeletedRole(searchWord: string): Observable<IEmployeeRole[]> {
    return this.http.get<IEmployeeRole[]>(`${this.urlRole}Users/${searchWord}`);
  }

  updateLoggedUserRole(): Observable<void> {
    return this.http.post<void>(`${this.urlRole}User/OnLogin`, null);
  }
}
